const setArticleLink = (url = '') => {
	if (url) {
		document.querySelector('.article-wrapper > .information > .source')
			.setAttribute('href', url);
		return;
	}

	document.querySelector('.article-wrapper > .information > .source')
		.classList
		.add('-hide');
};

export default setArticleLink;



// WEBPACK FOOTER //
// ./src/js/about/setArticleLink.js